export default __webpack_public_path__ + "static/media/elastic_operator.4a5fdee7.png";